import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { mapDBKeyWithFormName } from "../utils";
import { editJob } from "../features/jobs/jobsSlice";

const EditJob = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [updatedJob, setUpdatedJob] = useState({
    title: "",
    type: "",
    salary: "",
    deadline: "",
  });

  const handleJobChange = (e) => {
    const { name, value } = e.target;
    let updatedName = mapDBKeyWithFormName(name);
    setUpdatedJob({ ...updatedJob, [updatedName]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log(updatedJob);
    dispatch(editJob(updatedJob));
    navigate("/");
  };

  // redirect to home page if no job found
  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      const { job } = location.state;
      // setJob(job);
      setUpdatedJob(job);
    }
  }, [location.state, navigate]);

  return (
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
      <div className="lg:pl-[14rem] mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <h1 className="mb-10 text-center lws-section-title">Add New Job</h1>

          <div className="max-w-3xl mx-auto">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="fieldContainer">
                <label
                  htmlFor="lws-JobTitle"
                  className="text-sm font-medium text-slate-300"
                >
                  Job Title
                </label>
                <select
                  id="lws-JobTitle"
                  name="lwsJobTitle"
                  value={updatedJob.title}
                  onChange={handleJobChange}
                  required
                >
                  <option value="" hidden>
                    Select Job
                  </option>
                  <option>Software Engineer</option>
                  <option>Software Developer</option>
                  <option>Full Stack Developer</option>
                  <option>MERN Stack Developer</option>
                  <option>DevOps Engineer</option>
                  <option>QA Engineer</option>
                  <option>Product Manager</option>
                  <option>Social Media Manager</option>
                  <option>Senior Executive</option>
                  <option>Junior Executive</option>
                  <option>Android App Developer</option>
                  <option>IOS App Developer</option>
                  <option>Frontend Developer</option>
                  <option>Frontend Engineer</option>
                </select>
              </div>

              <div className="fieldContainer">
                <label htmlFor="lws-JobType">Job Type</label>
                <select
                  id="lws-JobType"
                  name="lwsJobType"
                  value={updatedJob.type}
                  onChange={handleJobChange}
                  required
                >
                  <option value="" hidden>
                    Select Job Type
                  </option>
                  <option>Full Time</option>
                  <option>Internship</option>
                  <option>Remote</option>
                </select>
              </div>

              <div className="fieldContainer">
                <label htmlFor="lws-JobSalary">Salary</label>
                <div className="flex border rounded-md shadow-sm border-slate-600">
                  <span className="input-tag">BDT</span>
                  <input
                    type="number"
                    name="lwsJobSalary"
                    id="lws-JobSalary"
                    required
                    value={updatedJob.salary}
                    onChange={handleJobChange}
                    className="!rounded-l-none !border-0"
                    placeholder="20,00,000"
                  />
                </div>
              </div>

              <div className="fieldContainer">
                <label htmlFor="lws-JobDeadline">Deadline</label>
                <input
                  type="date"
                  name="lwsJobDeadline"
                  id="lws-JobDeadline"
                  value={updatedJob.deadline}
                  onChange={handleJobChange}
                  required
                />
              </div>

              <div className="text-right">
                <button
                  type="submit"
                  id="lws-submit"
                  className="cursor-pointer btn btn-primary w-fit"
                >
                  Edit
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EditJob;
